import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3536 20.0214V15.6413C10.3536 15.1766 10.5382 14.7309 10.8668 14.4024C11.1954 14.0738 11.641 13.8892 12.1057 13.8892C12.5703 13.8892 13.016 14.0738 13.3446 14.4024C13.6731 14.7309 13.8577 15.1766 13.8577 15.6413V20.0214M5.97349 4.25293H6.84952C7.08185 4.25293 7.30467 4.34522 7.46896 4.50951C7.63325 4.6738 7.72554 4.89662 7.72554 5.12896V6.88101H10.3536V5.12896C10.3536 4.89662 10.4459 4.6738 10.6102 4.50951C10.7745 4.34522 10.9973 4.25293 11.2296 4.25293H12.9817C13.214 4.25293 13.4369 4.34522 13.6011 4.50951C13.7654 4.6738 13.8577 4.89662 13.8577 5.12896V6.88101H16.4858V5.12896C16.4858 4.89662 16.5781 4.6738 16.7424 4.50951C16.9067 4.34522 17.1295 4.25293 17.3618 4.25293H18.2378C18.4702 4.25293 18.693 4.34522 18.8573 4.50951C19.0216 4.6738 19.1139 4.89662 19.1139 5.12896V8.97821C19.1143 10.7888 19.1142 14.5715 19.1141 17.2553C19.114 18.9121 17.7709 20.2529 16.1141 20.2529H8.09722C6.44046 20.2529 5.09736 18.9121 5.09728 17.2553C5.09715 14.5715 5.09706 10.7888 5.09747 8.97821V5.12896C5.09747 4.89662 5.18976 4.6738 5.35405 4.50951C5.51833 4.34522 5.74115 4.25293 5.97349 4.25293Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHome;
